<script>
  import { onInterval } from '../clockutil.js';
  let seconds = 0;
  let thing = 0;

  onInterval(() => seconds += 1, 10);
  onInterval(() => thing += 3, 100)
  onInterval(() => seconds = 0, 100000);
  onInterval(() => thing = 0, 100000);

</script>

<style>
.absoluteBox {
  position: fixed;
  left: 0;
  bottom: 0;
  margin-left: 5%;
  margin-bottom: 5%;
  z-index: 0;
}

p {
  font-family: monospace;
}
</style>

<div class="absoluteBox">
<p>{seconds} {thing}</p>
</div>
